export const NANNYML_API_ADDRESS = import.meta.env.VITE_NANNYML_API;
